import { HSConfiguration } from './hs-configuration';

export class FoldingDoorConfiguration extends HSConfiguration {
    type: 'folding_door' = 'folding_door';
}
